module.exports = __webpack_public_path__ + "img/loading.7a8cbb70.gif";